(function($) {
    $(document).on('click', '.pagination .pagination__link', function(event) {
        setTimeout(function() {uwl_script_collection_ajax();}, 2000);

        setTimeout(function() {uwl_script_collection_ajax();}, 5000);
    });
})(jQuery);

(function($) {
    if (window.location.href.includes('/products/')) {
        $(window).on('load', function() {
            setTimeout(function() {uwl_script_collection_ajax();}, 2000);

            setTimeout(function() {uwl_script_collection_ajax();}, 5000);

            // Extra safety call after 3 seconds
            setTimeout(function() {uwl_script_collection_ajax();}, 15000);
        });
    }
})(jQuery);



